<template>
  <b-form-group
    :name="name"
    :label="label"
    :input-cols="inputCols">
    <template slot-scope="{ attrs, listeners }">
      <b-form-input
        :class="alignRight ? 'alignR' : 'alignL'"
        :disabled="disabled"
        :placeholder="placeholder"
        @input="m.$model[name] = m.$model[name].replace(',', '.')"
        v-bind="attrs"
        v-model.trim="m.$model[name]"
        v-on="listeners"/>
      <b-form-text v-if="hint !== null">{{ hint }}</b-form-text>
    </template>
  </b-form-group>
</template>

<script>
import bFormGroup from '@/components/FormGroup.vue'

export default {
  components: {
    bFormGroup
  },
  props: {
    label: {
      type: String,
      default: null,
      required: false,
    },
    m: {
      type: Object|Array,
      attribute: Object|Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    inputCols: {
      type: Number,
      default: 6,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
    alignRight: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
};
</script>
